

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-device-info/dist/index');

var _gdprCookieBanner = require('xo-models/src/gdprCookieBanner');

require('xo-ui-components/src/spinner/directive');

require('xo-page-components/src/merchant-header/directive');

require('xo-page-components/src/header/directive');

require('xo-page-components/src/shopping-cart-footer/directive');

require('xo-page-components/src/cart/directive');

require('xo-page-components/src/gdprCookieBanner/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-validation/dist/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {

    tag: 'xo-checkout',
    template: _template2['default'],
    lifecycle: {
        enter: function enter() {
            var _this = this;

            _logger.$logger.info('starting in shoppingcart enter');
            this.isApp = _index.$DeviceInfo.isApp();
            _angular.$document.bind('click', function (event) {
                _this.$broadcast('clickBody', event.target);
            });

            // TODO: fetch merchant details in merchant header from a model instead of passing from here
            this.merchant = {};
            _angular.$rootScope.$on('merchantDetails', function (event, data) {
                _this.merchant = data;
            });
            function fetchJsButtonScript() {
                var head = document.getElementsByTagName('head')[0];
                if (!head) {
                    return;
                }
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = 'https://www.paypalobjects.com/api/button.js';
                head.appendChild(script);
            }
            fetchJsButtonScript();
            this.isOpenButton = _angular.$rootScope.isOpenButton;
            this.isShoppingCart = _angular.$rootScope.isShoppingCart;
            function setDirectionality() {
                _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
            }

            this.$on('metadataChange', setDirectionality);
            setDirectionality();
            this.isGdprValid = _gdprCookieBanner.isGdprValid;
        }
    }
});


_angular.$document;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_index.$DeviceInfo;

_angular.$rootScope;

_gdprCookieBanner.isGdprValid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/directive.js
// module id = ./pages/xo-checkout/directive.js
// module chunks = 0